/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import { useStore } from "vuex";
import Chart from "chart.js";
import jwt_decode from "jwt-decode";
import store from "@/store";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";
// let testarray= [];
export default {
  name: "kpilist",
  components: {
    VPagination,
    customModal,
    Multiselect
  },
  async mounted() {

    const idtoken = store.getters.getIdToken;
    this.useremail = jwt_decode(idtoken).email;
    this.headers = {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    };
    window.addEventListener("studyIdChanged", async (event) => {


      await this.getOverdueVisitslist();
      this.getsites();
      this.getVisitTypes();


    });
    await this.getVisitTypes();
    await this.getOverdueVisitslist();
    await this.setRoleList();
    await this.onRoleChange();
    this.getsites();


  },
  data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      dropdownOpen: false,
      showOverdueLoading: false,
      searchField: {
        status: "",
        siteCode: ""
      },
      overdueVisitList: [],
      checklists: [],
      currentoverduePage: 1,
      totaloverduePages: 0,
      pageoverduesize: 10,
      sProp: "",
      IsDesc: true,
      pageNumber: 1,
      pageoverdueindex: 1,
      showRisksModal: false,
      selectedSite: null,
      showScheduleModal: false,
      scheduleForm: {
        siteCode: '',
        plannedDate: '',
        immediateDate: null,
        //craVisitType: '',
        overridePlannedDate: false,
        craVisitType: "Unscheduled Visit",
        craVisitTypeId: '',
        monitoringMode: '',
        triggeredBy: '',
        triggeredByComment: '',
        visitName: '',
        craid: '',
        status: '',
        checklist: []
      },
      userList: [],
      roleList: [],
      sites: [],
      formErrors: {},
      visitTypes: [],


      craVisitTypeOptions: ['Site Initiation Visit', 'Interim Monitoring Visit', 'Close-Out Visit', 'Remote Monitoring Visit', 'For-Cause Visit'],
      monitoringModeOptions: ['Onsite', 'Remote', 'Hybrid', 'Central'],
      triggeredByOptions: ['Protocol Scheduled', 'Risk Signal Detected', 'Major Protocol Deviation', 'High Query Rate', 'High AE Rate', 'Missed Visit', 'Manual Assignment', 'Regulatory Requirement', 'Others'],

    };
  },
  methods: {
    async getOverdueVisitslist() {
      const currentstudyid = store.getters.getStudyIs;
      this.showOverdueLoading = true;
      await axios.get(`${this.baseapi}/forms/cra/kpilistwithsite?studyId=${currentstudyid}&siteCode=${this.searchField.siteCode}&status=${this.searchField.status}&SortProperty=siteScore&SortOrder=1`, this.headers)
        .then((res) => {
          console.log('KPI Response:', res.data.entities); // Debug log

          // Handle both array directly or nested in data property
          this.overdueVisitList = Array.isArray(res.data.entities)
            ? res.data.entities
            : [];
          this.totalCountOverdue = this.overdueVisitList.length || 0;
          this.totaloverduePages = parseInt(this.totalCountOverdue / this.pageoverduesize)
          if ((this.totalCountOverdue % this.pageoverduesize) != 0) {
            this.totaloverduePages = this.totaloverduePages + 1
          }
          this.showOverdueLoading = false;
        })
        .catch((err) => {
          console.error('KPI Error:', err); // Debug log
          this.showOverdueLoading = false;
          this.overdueVisitList = [];
        })
    },
    async onRoleChange() {
      if (!this.craRoleId) {
        console.warn("CRA role not found");
        return;
      }

      const currentstudyid = store.getters.getStudyIs;

      const res = await axios.get(
        `${this.baseapi}/account-core/user/getusersbyrole`,
        {
          params: {
            roleids: this.craRoleId,
            studyid: currentstudyid
          },
          headers: {
            Authorization: this.headers.headers.Authorization
          }
        }
      );

      this.userList = res.data || [];
    },

    search() {
      this.pageindex = 1;
      this.currentPage = 1;
      this.getOverdueVisitslist();
    },
    loadOverdue: function (page) {
      this.currentformPage = page;
      this.pageoverdueindex = this.currentoverduePage;
      this.getOverdueVisitslist();
    },

    openRisksModal(siteData) {
      this.selectedSite = siteData;
      this.showRisksModal = true;
    },

    closeRisksModal() {
      this.showRisksModal = false;
      this.selectedSite = null;
    },
    async getVisitTypes() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;
      const res = await axios.get(
        `${this.baseapi}/forms/cra/getcravisittype`,
        {
          params: { studyId: studyId },
          headers: { Authorization: `Bearer ${idtoken}` }
        }
      );
      this.visitTypes = res.data || [];
    },
   async onVisitTypeChange() {
  this.scheduleForm.checklist = [];
  this.checklists = [];

  if (!this.scheduleForm.craVisitTypeId) return;

  const selectedVisit = this.visitTypes.find(
    v => v.id === this.scheduleForm.craVisitTypeId
  );

  this.scheduleForm.craVisitType = selectedVisit?.type || "";

  const idtoken = store.getters.getIdToken;
  const studyId = store.getters.getStudyIs;

  const res = await axios.get(
    `${this.baseapi}/forms/cra/getchecklistbyvisit`,
    {
      params: {
        visitId: selectedVisit.id,
        studyId
      },
      headers: { Authorization: `Bearer ${idtoken}` }
    }
  );

  this.checklists = (res.data?.checklist || []).map(item => ({
    value: item.checklistId,
    label: item.title,
    questions: item.questions
  }));
},




    async createSchedule() {
      // Open the schedule modal and bind the site code
      this.scheduleForm.siteCode = this.selectedSite?.siteCode || '';
      this.scheduleForm.studyName = this.selectedSite?.studyName || '';
      this.scheduleForm.immediateDate = null;
      const unscheduled = this.visitTypes.find(
        v => v.type === "Unscheduled Visit"
      );
      if (unscheduled) {
        this.scheduleForm.craVisitTypeId = unscheduled.id;
        this.scheduleForm.craVisitType = unscheduled.type;
        await this.$nextTick();
        await this.onVisitTypeChange();
      
      }

      // this.scheduleForm.overridePlannedDate = false;
      // this.scheduleForm.craVisitType = '';
      this.scheduleForm.monitoringMode = '';
      this.scheduleForm.triggeredBy = '';
      // Fetch planned date from CRA assign list API
      this.fetchPlannedDate();
      this.showScheduleModal = true;
    },
    async setRoleList() {
      const res = await axios.get(
        `${this.baseapi}/account-core/roles/rolelist`,
        this.headers
      );
      this.roleList = res.data || [];
    },

    async fetchPlannedDate() {
      try {
        const currentstudyid = store.getters.getStudyIs;

        let siteId = this.selectedSite?.siteId;
        if (!siteId && this.selectedSite?.risks && this.selectedSite.risks.length > 0) {
          siteId = this.selectedSite.risks[0].siteId;
        }

        if (!siteId) {
          console.error('Site ID not found');
          this.scheduleForm.plannedDate = '';
          return;
        }
        console.log('Fetching planned date for Site ID:', siteId);
        const response = await axios.get(
          `${this.baseapi}/forms/cra/craassignlist?StudyId=${currentstudyid}&SiteId=${siteId}`,
          this.headers
        );
        if (response.data.results && response.data.results.length > 0) {
          const result = response.data.results[0];
          if (result.studies && result.studies.length > 0) {
            const study = result.studies[0];
            if (study.sites && study.sites.length > 0) {
              const site = study.sites[0];
              if (site.plannedDate) {
                const plannedDateObj = new Date(site.plannedDate);
                const formattedDate = plannedDateObj.toISOString().split('T')[0];
                this.scheduleForm.plannedDate = formattedDate;
                console.log('Planned Date fetched:', formattedDate);
              }
            }
          }
        }
      } catch (err) {
        console.error('Error fetching planned date:', err);
        this.scheduleForm.plannedDate = '';
      }
    },

    closeScheduleModal() {
      this.showScheduleModal = false;
      this.formErrors = {};
      this.scheduleForm = {
        siteCode: '',
        plannedDate: '',
        immediateDate: null,
        // overridePlannedDate: false,
        craVisitType: 'Unscheduled Visit',
        monitoringMode: '',
        triggeredBy: '',
        status: '',
        craid: '',
        checklist: []
      };
    },
    validateForm() {
      this.formErrors = {};

      if (!this.scheduleForm.craid) {
        this.formErrors.cra = "CRA is required";
      }
      return Object.keys(this.formErrors).length === 0;
    },

    submitSchedule() {
      // Validate form data
      // if (!this.scheduleForm.craVisitType || !this.scheduleForm.monitoringMode || !this.scheduleForm.triggeredBy) {
      //   alert('Please fill in all required fields');
      //   return;
      // }
      if (!this.validateForm()) {
        return;
      }

      const currentstudyid = store.getters.getStudyIs;
      const studyname = store.getters.getStudyIs;


      let siteId = this.selectedSite?.siteId;
      if (!siteId && this.selectedSite?.risks && this.selectedSite.risks.length > 0) {
        siteId = this.selectedSite.risks[0].siteId;
      }

      const payload = {
        studyId: currentstudyid,
        craId: this.scheduleForm.craid,
        studyName: studyname,
        siteId: siteId,
        siteCode: this.scheduleForm.siteCode,
        plannedDate: new Date(this.scheduleForm.plannedDate).toISOString(),
        immediateDate: null,
        overridePlannedDate: false,
        craVisitType: this.scheduleForm.craVisitType,
        craVisitTypeId: this.scheduleForm.craVisitTypeId,
        visitName: this.scheduleForm.visitName,
        monitoringMode: this.scheduleForm.monitoringMode,
        reason: this.scheduleForm.triggeredBy,
        comments: this.scheduleForm.triggeredBy === 'Others' ? this.scheduleForm.triggeredByComment : '',
        status: this.scheduleForm.status,
        checklist: this.scheduleForm.checklist

      };

      // Make API call
      axios.post(`${this.baseapi}/forms/cra/craschedulecreate`, payload, this.headers)
        .then((res) => {
          console.log('Schedule Created Successfully:', res.data);
          alert('CRA Schedule created successfully');
          this.closeScheduleModal();
          this.closeRisksModal();
          // Optionally refresh the KPI list
          this.getOverdueVisitslist();
        })
        .catch((err) => {
          console.error('Error creating schedule:', err);
          alert('Error creating CRA Schedule. Please try again.');
        })
    },
    async getsites() {
      let idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;
      const res = await axios.get(
        `${this.baseapi}/management/site/getall`,
        {
          params: { studyId: studyId },
          headers: { Authorization: `Bearer ${idtoken}` }
        }
      );
      this.sites = res.data || [];
    },
  },
  computed: {
    hasRisks() {
      return this.selectedSite && this.selectedSite.risks && this.selectedSite.risks.length > 0;
    },
    craRoleId() {
      const craRole = this.roleList.find(
        r => r.roleName?.toUpperCase() === "CRA"
      );
      return craRole?.roleID || "";
    },
  }
};